import {config} from "../config/config";
import {utils} from "@utils/utils";
import logUtils from "../utils/log-utils";

export default class Reporter {
	constructor() {
		this.startReport();
		this.bindHideEvent();
	}
	//发起网络请求，上报日志
	async doReport(){
		//从localStorage中读取日志
		let logContents = logUtils.getLogs();
		if( logContents.length === 0){
			return;
		}
		let reportResult = null;
		let formData = new FormData();
		for(let log of logContents){
			formData.append("logContent", log);
		}
		try {
			reportResult = await utils.sendData(config.LOG_REPORT_API_URL,formData);
			//上报成功后清空localStorage
			localStorage.removeItem(config.LOG_CACHE_KEY);
		} catch (error) {
			console.error(error);
		}
	}
	//开始轮询检查上报
	startReport(){
		//每五秒上传一次日志
		if(!this.timerId){
			this.timerId = setInterval(this.doReport, config.TIMER_POLL_INTERVAL);
		}
	}
	//停止轮询上报
	stopReport(){
		clearInterval(this.timerId);
	}
	//页面隐藏的时候绑定事件
	bindHideEvent(){
		let self = this;
		document.addEventListener("visibilitychange", function () {
			if (document.visibilityState === "hidden") {
				self.doReport();
				self.stopReport();
			}
			if (document.visibilityState === "visible") {
				self.startReport();
			}
		});
	}
}